// Ported from v3 `src/utils/gtm.js` (contract 05 §3, analysis §7 — "5 lines, no coupling").
// A pure GTM `dataLayer` primitive: it queues one event on `window.dataLayer`, nothing more.
// The prod + `GTM_ID` gate and `front_url` enrichment deliberately live at the sole call site
// (`app/shell/useRouteAnalytics`), NOT here — this util stays decoupled from `env` so it is
// trivially testable and reusable.

export interface DataLayerEvent {
  /** GTM event name (e.g. `page_change`, `feature_used`). */
  event: string
  [key: string]: unknown
}

/** The `window` fields GTM relies on — declared locally to avoid a global augmentation. */
interface DataLayerWindow {
  dataLayer?: DataLayerEvent[]
}

/** Push one event onto `window.dataLayer`, creating the queue on first use (v3 parity). */
export function pushToDataLayer(event: DataLayerEvent): void {
  const target = window as unknown as DataLayerWindow
  target.dataLayer ??= []
  target.dataLayer.push(event)
}
